module.exports = __webpack_public_path__ + "static/media/icon_arrow_left.2a87b18c.svg";